/* Hitch: Web Share with desktop fallback */
(function () {
  function onReady(fn){ if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",fn);} else {fn();} }
  onReady(function(){
    document.querySelectorAll(".hitch-share").forEach(function(root){
      var btn  = root.querySelector(".hitch-share__btn");
      var menu = root.querySelector(".hitch-share__menu");
      var url   = root.getAttribute("data-share-url")   || window.location.href;
      var title = root.getAttribute("data-share-title") || document.title;

      function closeMenu(){ if(menu){ menu.classList.remove("open"); btn && btn.setAttribute("aria-expanded","false"); } }
      function openMenu(){ if(menu){ menu.classList.add("open");  btn && btn.setAttribute("aria-expanded","true"); } }

      btn && btn.addEventListener("click", function(e){
        e.preventDefault();
        if (navigator.share) {
          navigator.share({ title: title, url: url }).catch(function(){ openMenu(); });
        } else {
          menu && (menu.classList.contains("open") ? closeMenu() : openMenu());
        }
      });

      var copyBtn = root.querySelector(".hs-copy");
      copyBtn && copyBtn.addEventListener("click", function(){
        var toCopy = copyBtn.getAttribute("data-copy") || url;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(toCopy).then(function(){
            copyBtn.textContent = "Copied!";
            setTimeout(function(){ copyBtn.textContent = "Copy link"; }, 1600);
          });
        } else {
          var ta = document.createElement("textarea"); ta.value = toCopy; document.body.appendChild(ta); ta.select();
          try{ document.execCommand("copy"); }catch(e){}
          document.body.removeChild(ta);
          copyBtn.textContent = "Copied!";
          setTimeout(function(){ copyBtn.textContent = "Copy link"; }, 1600);
        }
      });

      document.addEventListener("click", function(e){ if(!root.contains(e.target)) closeMenu(); }, { passive: true });
    });
  });
})();
